// External Packages
import React, { useState, useEffect } from 'react'
import {
    Typography,
    Grid,
    Avatar,
    Paper,
    TextField,
    Button,
    Chip,
    Snackbar
} from '@material-ui/core/index'
import {
    PlayCircleOutline as StartIcon,
    FormatListNumbered as ListIcon,
    HighlightOff as StopIcon
} from '@material-ui/icons/index'
import { useMediaQuery } from 'react-responsive'
// Internal Imports
import useStyles from './HomeStyle'
import STRINGS from '../../Resources/strings.json'
import IMAGES from '../../Resources/images.json'
import * as FIREBASE from '../../Services/firebase'
import AdviceCard from '../../Components/AdviceCard/AdviceCard'

function Home() {

    const classes = useStyles()

    const [advice, setAdvice] = useState("")
    const [error, setError] = useState(false)

    const [previous, setPrevious] = useState([])

    const [alertOpen, setAlertOpen] = useState(false)

    const handleClose = () => {
        setAlertOpen(false) 
    }   

    const submitAdvice = () => {
        if (advice.length === 0) {
            setError(true)
        } else {
            var obj = {
                "timestamp": Date.now(), 
                "message": advice
            }
    
            FIREBASE.addToCollection('advice', obj)
            setAdvice("")
            setPrevious(oldArray => [obj, ...oldArray])
            setAlertOpen(true)
        }
    }

    const isDesktopOrLaptop = useMediaQuery({
        query: '(min-width: 1224px)'
    })

    const handleChange = (e) => {
        var val = e.target.value
        setError(false)
        setAdvice(val)
    }

    const creationDate = new Date(STRINGS.creation)

    useEffect(() => {
        if (previous.length === 0) {
            FIREBASE.getAllFromCollection('advice', (a) => {
                setPrevious(oldArray => [...oldArray, a])
            })
        }
    }, [previous.length])

    const deathDate = () => {
        var result = new Date(STRINGS.creation)
        result.setDate(result.getDate() + previous.length);
        return result
    }

    const reportSpam = (a) => {
        setPrevious(oldArray => {
            const index = oldArray.indexOf(a)
            if (index > -1) {
                oldArray.splice(index, 1)
            }

            return oldArray
        })

        FIREBASE.addToCollection('spamreports', a)

        setAlertOpen(true)
    }

    if (new Date() > deathDate()) {
        return (
            <div>
                <Grid 
                    container 
                    justify='center' 
                    className={classes.gridContainer}
                    spacing={5}>

                    <Grid item xs={12}>
                        <Typography variant='h2' >{STRINGS.homeMainTitle}</Typography>
                    </Grid>

                    <Grid item xs={isDesktopOrLaptop ? 7 : 12}>
                        <Paper className={classes.introPaper}>
                            {STRINGS.homeDeathMsg.map(pg => <Typography paragraph variant='h5'>{pg}</Typography>)}
                        </Paper>
                    </Grid>
                </Grid>

                <Grid container justify='center' align='center' className={classes.gridContainer} spacing={2}>
                    <Grid item>
                        <Typography variant='h4'> {STRINGS.homeMadeByText} </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <a href='https://joealexanderrackham.co.uk'>
                            <Typography variant='h6'> https://joealexanderrackham.co.uk </Typography>
                        </a>
                    </Grid>
                    <Grid item xs={12}>
                        <a href='https://joealexanderrackham.co.uk'>
                            <Avatar
                                className={classes.avatar}
                                src={IMAGES.avatar}
                            />
                        </a>
                    </Grid>
                </Grid>
            </div>
        )
    }

    return (
        <div> 
            <Grid 
                container 
                justify='center' 
                className={classes.gridContainer}
                spacing={5}>

                <Grid item xs={12}>
                    <Typography variant='h2' >{STRINGS.homeMainTitle}</Typography>
                </Grid>

                <Grid item xs={isDesktopOrLaptop ? 7 : 12}>
                    <Paper className={classes.introPaper}>
                        {STRINGS.homeIntroText.map(pg => <Typography paragraph variant='h5'>{pg}</Typography>)}
                    </Paper>
                </Grid>

            </Grid>

            <Grid 
                container 
                justify='center' 
                className={classes.gridContainer}
                spacing={1}>

                <Chip 
                    className={classes.infoChip} 
                    color='primary'
                    icon={<StartIcon/>}
                    label={'Site was setup ' + creationDate.toDateString()}/>

                <Chip 
                    className={classes.infoChip} 
                    color='primary'
                    icon={<ListIcon/>}
                    label={previous.length + ' Pieces of Advice shared since'}/>

                <Chip 
                    className={classes.infoChip} 
                    color='primary'
                    icon={<StopIcon/>}
                    label={'Site will last till ' + deathDate().toDateString()}/>

            </Grid>


            <Grid 
                container
                justify='center' 
                align='center' 
                className={classes.gridContainer} 
                spacing={2}
            >
                <Grid item xs={isDesktopOrLaptop ? 6 : 10}>
                    <TextField 
                        error={error}
                        fullWidth 
                        multiline 
                        value={advice}
                        onChange={handleChange}
                        variant='outlined' 
                        label={isDesktopOrLaptop ? STRINGS.homeAdviceStarter : STRINGS.homeAdviceShort} />
                </Grid>
                <Grid item xs={12}>
                    <Button
                        onClick={submitAdvice} 
                        variant='contained' 
                        color='primary'>
                        Submit your advice!
                    </Button>
                </Grid>
            </Grid>

            <Grid 
                container 
                justify='center' 
                className={classes.gridContainer}
                spacing={2}>

                <Grid item xs={12}>
                    <Typography variant='h4' >{STRINGS.homePreviousAdvice}</Typography>
                </Grid>

                {previous.map((a) => (<Grid item xs={isDesktopOrLaptop ? 4 : 12} key={a.timestamp}>
                    <AdviceCard advice={a} reportSpam={reportSpam} />
                </Grid>))}
            </Grid>

            <Grid container justify='center' align='center' className={classes.gridContainer} spacing={2}>
                <Grid item>
                    <Typography variant='h4'> {STRINGS.homeMadeByText} </Typography>
                </Grid>
                <Grid item xs={12}>
                    <a href='https://joealexanderrackham.co.uk'>
                        <Typography variant='h6'> https://joealexanderrackham.co.uk </Typography>
                    </a>
                </Grid>
                <Grid item xs={12}>
                    <a href='https://joealexanderrackham.co.uk'>
                        <Avatar
                            className={classes.avatar}
                            src={IMAGES.avatar}
                        />
                    </a>
                </Grid>
            </Grid>

            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={alertOpen}
                onClose={handleClose}
                message="Submitted"
            />

        </div>)
}

export default Home